<template>
  <div>
    <v-text-field
      outlined
      hide-details
      :label="label"
      class="mb-2"
      :value="value"
      @input="onInput"
    >
      <template v-slot:append v-if="canRemove">
        <v-icon color="red" @click="onRemoveClick">
          mdi-delete-outline
        </v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "TextArrayInputField",
  props: {
    canRemove: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    path: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value, this.path, this.index)
    },
    onRemoveClick() {
      this.$emit("remove", this.path, this.index)
    },
  },
}
</script>
